import React from 'react'
import Tooltip, { ALIGN, POSITION } from 'gnos-tooltip'

import './style.scss'

export default function GdprIcon({ id, block, children }) {
    return (
        <>
            <Tooltip
                id={`${block}-gdpr-tooltip-${id}`}
                content={children}
                position={POSITION.TOP}
                align={ALIGN.LEFT}
                width={'500px'}
            >
                <div className={'gdpr-icon'} />
            </Tooltip>
        </>
    )
}
